import { alpha } from "@mui/material/styles";

export const addressFieldUi = {
  border: "#e6e9ee",
  borderStrong: "#d9dee7",
  text: "#182230",
  muted: "#667085",
  subtle: "#98a2b3",
  soft: "#f8fafc",
  hover: "#f4f6f8",
};

export const addressValueInputSx = {
  minWidth: 0,

  "& .MuiInputLabel-root": {
    color: addressFieldUi.muted,
    fontSize: 10.6,
    lineHeight: 1,
    transform: "translate(12px, 8px) scale(1)",
    transformOrigin: "top left",
  },

  "& .MuiInputLabel-root.MuiInputLabel-shrink": {
    transform: "translate(12px, -5px) scale(0.75)",
  },

  "& .MuiOutlinedInput-root": {
    height: 36,
    borderRadius: 0.9,
    bgcolor: "#fff",
    fontSize: 11.6,
    color: addressFieldUi.text,
    transition:
      "border-color 120ms ease, box-shadow 120ms ease, background-color 120ms ease",

    "& fieldset": {
      borderColor: addressFieldUi.borderStrong,
    },

    "&:hover fieldset": {
      borderColor: "#c5ccd6",
    },

    "&.Mui-focused fieldset": {
      borderWidth: 1,
      borderColor: "primary.main",
    },

    "&.Mui-focused": {
      boxShadow: theme =>
        `0 0 0 3px ${alpha(
          theme.palette.primary.main,
          0.055
        )}`,
    },
  },

  "& .MuiOutlinedInput-input": {
    height: 36,
    boxSizing: "border-box",
    px: 1.05,
    py: 0,
    lineHeight: "36px",
    transform: "translateY(-0.5px)",
  },

  "& .MuiSelect-select": {
    minHeight: "36px !important",
    height: "36px !important",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    px: "10px !important",
    py: "0 !important",
    transform: "translateY(-0.5px)",
  },
};

export default addressFieldUi;
